const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const SHOP_CODE = process.env.REACT_APP_SHOP_CODE;
const SHOP_ID = process.env.REACT_APP_SHOP_ID;
const STATIC_TOKEN = process.env.REACT_APP_STATIC_TOKEN;

class ApiService {

    // Get current URL for dynamic shop validation 
  getCurrentUrl() {
    return window.location.origin; // Returns http://localhost:3000 or your actual domain
  }
// Initiate login process - send OTP
async initiateLogin(userData) {
  try {
    const payload = {
      url: this.getCurrentUrl(),
      shop_code: SHOP_CODE,
      name: userData.name,
      email: userData.email
    };

    console.log('Sending login request:', payload);

    const response = await fetch(`${API_BASE_URL}/fe/login`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    console.log('Login API response:', data);

    // Return standardized response
    return {
      success: data.success === true,
      message: data.message || '',
      data: data.data || null
    };

  } catch (error) {
    console.error('Failed to initiate login:', error);
    return {
      success: false,
      message: 'Network error. Please try again.',
      data: null
    };
  }
}

// Verify OTP
async verifyOtp(otpData) {
  try {
    const payload = {
      url: this.getCurrentUrl(),
      shop_code: SHOP_CODE,
      email: otpData.email,
      otp: otpData.otp
    };

    console.log('Sending OTP verification request:', payload);

    const response = await fetch(`${API_BASE_URL}/fe/verify-otp`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    console.log('OTP verification API response:', data);

    // Return standardized response
    return {
      success: data.success === true,
      message: data.message || '',
      data: data.data || null
    };

  } catch (error) {
    console.error('Failed to verify OTP:', error);
    return {
      success: false,
      message: 'Network error. Please try again.',
      data: null
    };
  }
}


 // Apply promo code discount
  // async applyPromoCode(promoData) {
  //   try {
  //     const payload = {
  //       shop_code: SHOP_CODE,
  //       shop_id: SHOP_ID,
  //       promo_code: promoData.promo_code,
  //       booking_details: promoData.booking_details,
  //       room_details: promoData.room_details,
  //       subtotal: promoData.subtotal
  //     };

  //     console.log('Sending promo code request:', payload);

  //     const response = await fetch(`${API_BASE_URL}/fe/promo-discount`, {
  //       method: 'POST',
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(payload)
  //     });

  //     const data = await response.json();

  //     if (!response.ok) {
  //       // Return the error response from API instead of throwing
  //       return data;
  //     }

  //     console.log('Promo code application success:', data);
  //     return data;

  //   } catch (error) {
  //     console.error('Failed to apply promo code:', error);
  //     throw error;
  //   }
  // }

  // Apply promo code discount - UPDATED VERSION
async applyPromoCode(promoData) {
  try {
    const checkIn = new Date(promoData.booking_details.check_in);
    const checkOut = new Date(promoData.booking_details.check_out);
    const userToken = sessionStorage.getItem('userToken');
    const isUserLoggedIn = !!userToken;

    const formattedBookingDetails = {
      ...promoData.booking_details,
      check_in: checkIn.toISOString(),
      check_out: checkOut.toISOString(),
      total_nights: promoData.booking_details.total_nights || 
        Math.ceil((checkOut - checkIn) / (1000 * 60 * 60 * 24))
    };

    const payload = {
      shop_code: SHOP_CODE,
      shop_id: SHOP_ID,
      is_user_logged_in: isUserLoggedIn ? "true" : "false",
      promo_code: promoData.promo_code.trim(),
      booking_details: formattedBookingDetails,
      room_details: promoData.room_details.map(room => ({
        ...room,
        room_price: parseFloat(room.room_price),
        original_price: parseFloat(room.original_price || room.room_price * 1.1),
        quantity: parseInt(room.quantity) || 1
      })),
      subtotal: parseFloat(promoData.subtotal)
    };

    const response = await fetch(`${API_BASE_URL}/fe/promo-discount`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message: data.message || 'Failed to apply promo code',
        data: data.data || null,
        status: response.status
      };
    }

    return {
      success: true,
      message: data.message || 'Promo code applied successfully',
      data: data.data || null
    };

  } catch (error) {
    console.error('Failed to apply promo code:', error);
    return {
      success: false,
      message: 'Network error. Please try again.',
      error: error.message,
      data: null
    };
  }
}

// Helper method to calculate totals with promo code
calculateTotalsWithPromo(originalTotals, promoResponse) {
  if (!promoResponse || !promoResponse.success) {
    return originalTotals;
  }

  const discountedData = promoResponse.data.discounted_charges;
  const originalData = promoResponse.data.original_charges;
  const savings = promoResponse.data.savings_summary;

  return {
    ...originalTotals,
    subtotal: discountedData.subtotal,
    totalTax: discountedData.taxes.grand_total - discountedData.subtotal,
    grandTotal: discountedData.taxes.grand_total,
    originalSubtotal: originalData.subtotal,
    originalGrandTotal: originalData.subtotal + (originalData.taxes?.total_tax || 0),
    totalSavings: savings.total_savings,
    savingsPercentage: savings.savings_percentage,
    promoCode: promoResponse.data.promo_code_info,
    roomDetails: promoResponse.data.room_details
  };
}



// Add this method to your apiService.js
async applyPromoCodeToCart(promoData) {
  try {
    const checkIn = new Date(promoData.booking_details.check_in);
    const checkOut = new Date(promoData.booking_details.check_out);
    const userToken = sessionStorage.getItem('userToken');
    const isUserLoggedIn = !!userToken;

    const formattedBookingDetails = {
      ...promoData.booking_details,
      check_in: checkIn.toISOString(),
      check_out: checkOut.toISOString(),
      total_nights: promoData.booking_details.total_nights || 
        Math.ceil((checkOut - checkIn) / (1000 * 60 * 60 * 24))
    };

    const payload = {
      shop_code: SHOP_CODE,
      shop_id: SHOP_ID,
      is_user_logged_in: isUserLoggedIn ? "true" : "false",
      promo_code: promoData.promo_code.trim(),
      booking_details: formattedBookingDetails,
      room_details: promoData.room_details.map(room => ({
        ...room,
        room_price: parseFloat(room.room_price),
        original_price: parseFloat(room.original_price || room.room_price * 1.1),
        quantity: parseInt(room.quantity) || 1
      })),
      subtotal: parseFloat(promoData.subtotal)
    };

    // Add offer_details if provided (for stackable promos)
    if (promoData.offer_details && promoData.offer_details.length > 0) {
      payload.offer_details = promoData.offer_details;
    }

    // Add is_stackable flag if provided
    if (promoData.is_stackable !== undefined) {
      payload.is_stackable = promoData.is_stackable;
    }

    console.log('Sending promo code request with payload:', payload);

    const response = await fetch(`${API_BASE_URL}/fe/promo-discount`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message: data.message || 'Failed to apply promo code',
        data: data.data || null,
        status: response.status
      };
    }

    return {
      success: true,
      message: data.message || 'Promo code applied successfully',
      data: data.data || null
    };

  } catch (error) {
    console.error('Failed to apply promo code:', error);
    return {
      success: false,
      message: 'Network error. Please try again.',
      error: error.message,
      data: null
    };
  }
}

// Helper method to calculate totals with promo
calculateTotalsWithPromo(originalTotals, promoResponse) {
  if (!promoResponse || !promoResponse.success) {
    return originalTotals;
  }

  const discountedData = promoResponse.data.discounted_charges;
  const originalData = promoResponse.data.original_charges;
  const savings = promoResponse.data.savings_summary;

  return {
    subtotal: discountedData.subtotal,
    taxes: discountedData.taxes.grand_total - discountedData.subtotal,
    total: discountedData.taxes.grand_total,
    originalSubtotal: originalData.subtotal,
    originalTotal: originalData.subtotal + (originalData.taxes?.total_tax || 0),
    totalDiscount: savings.total_savings,
    discountPercentage: savings.savings_percentage,
    promoCodeInfo: promoResponse.data.promo_code_info,
    roomDetails: promoResponse.data.room_details,
    hasDiscount: true
  };
}


  // Confirm booking
  async confirmBooking(bookingData) {
    try {

       // Check if user is logged in
      const userToken = sessionStorage.getItem('userToken');
      const isUserLoggedIn = !!userToken;

      const payload = {
        shop_code: SHOP_CODE,
        shop_id: SHOP_ID,
        is_user_logged_in: isUserLoggedIn ? "true" : "false",
        ...bookingData
      };

      console.log('Sending booking confirmation request:', payload);

      const response = await fetch(`${API_BASE_URL}/fo/reservationStoreFromNewRequest`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (!response.ok) {
        // Return the error response from API instead of throwing
        return data;
      }
      // Normalize the response
    const normalizedResponse = {
      ...data,
      success: data.code === 200 && data.response === "OK"
    };

    console.log('Booking confirmation response:', normalizedResponse);
    return normalizedResponse;

      // console.log('Booking confirmation success:', data);
      // return data;

    } catch (error) {
      console.error('Failed to confirm booking:', error);
      throw error;
    }
  }
  

  async getHotelList(searchTerm = '') {
    try {
      const params = {
        shop_id: SHOP_ID
      };

      if (searchTerm) {
        params.search = searchTerm;
      }
      console.log(SHOP_ID);
      const queryString = new URLSearchParams(params).toString();
      const url = `${API_BASE_URL}/fe/hotelList?${queryString}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const getHotelDisplayName = (name, city) => {
        if (!city || city.trim() === '') return name;
        return `${name} - ${city}`;
      };

      // Transform the API response to match our expected format
      if (data.data && Array.isArray(data.data)) {
        return data.data.map(hotel => ({
          id: hotel.id,
          name: getHotelDisplayName(hotel.name, hotel.city),
          tableName: hotel.tableName || null,
          status: hotel.status || 1,
          location: hotel.location || ''
        }));
      }

      return [];

    } catch (error) {
      console.error('Failed to fetch hotels:', error);
      return [];
    }
  }

  async getHotelData(hotelId, searchParams) {
    try {
       // Format rooms data as required
    const rooms_guests = searchParams.roomsData.map((room, index) => ({
      room_no: index + 1,
      no_of_adults: room.adults,
      no_of_children: room.children
    }));

      // Convert dates to Y-m-d format
      const formatDate = (dateString) => {
        return new Date(dateString).toISOString().split('T')[0];
      };


      // Check if user is logged in
      const userToken = sessionStorage.getItem('userToken');
      const isUserLoggedIn = !!userToken;

      const payload = {
        shop_id: SHOP_ID,
        id_mst_hotel: hotelId,
        start_date: formatDate(searchParams.startDate), // Convert to Y-m-d
        end_date: formatDate(searchParams.endDate),     // Convert to Y-m-d
        rooms: searchParams.rooms,
        guests: searchParams.guests,
        room_guest: rooms_guests,
        promo_code : searchParams.promo_code,
        is_user_logged_in: isUserLoggedIn ? "true" : "false"
      };

       console.log('API Payload:', payload);
     
       const url = `${API_BASE_URL}/fe/getFullHotelData`;

      const response = await fetch(url, {
      method: 'POST', // Change to POST
      headers: {
        'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload) // Send as JSON body
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log('API Response:', data);

      // return this.getStaticHotelData();
      
      return data;
      

    } catch (error) {
      console.error('Failed to fetch hotel data:', error);
      throw error;
      //  return this.getStaticHotelData();
    }
  }


   // Calculate taxes
  async calculateTaxes(amount, check_in_date, check_out_date, id_shop = SHOP_ID) {
    try {
      const payload = {
        type: "tariff",
        amount: amount.toString(),
        check_in_date: check_in_date,
        check_out_date: check_out_date,
        id_shop: id_shop
      };

      console.log('🔍 Tax calculation payload:', payload);

      const response = await fetch(`${API_BASE_URL}/fo/mstCalculation`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      
      if (!response.ok) {
        console.error('Tax calculation API error:', data);
        return {
          success: false,
          error: data.message || 'Tax calculation failed',
          data: data,
          fallbackTaxes: amount * 0.18 // 18% fallback
        };
      }

      console.log('✅ Tax calculation success:', data);
      return {
        success: true,
        data: data,
        totalTax: {
          baseAmount: data.total_tax?.base_amount_total || 0,
          cgst: data.total_tax?.total_cgst_amount_after_tax || 0,
          sgst: data.total_tax?.total_sgst_amount_after_tax || 0,
          cess: data.total_tax?.total_cess_amount || 0,
          grandTotal: data.total_tax?.grand_total || 0
        },
        dailyBreakdown: data.daily_breakdown || []
      };
      
    } catch (error) {
      console.error('❌ Tax calculation failed:', error);
      return {
        success: false,
        error: error.message,
        fallbackTaxes: amount * 0.18 // 18% fallback
      };
    }
  }

  // Or if you want a simpler version that just returns the API data:
  async calculateTaxesSimple(amount, check_in_date, check_out_date, id_shop = SHOP_ID) {
    try {
      const payload = {
        type: "tariff",
        amount: amount.toString(),
        check_in_date: check_in_date,
        check_out_date: check_out_date,
        id_shop: id_shop
      };

      const response = await fetch(`${API_BASE_URL}/fo/mstCalculation`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Tax calculation failed');
      }

      return data;
      
    } catch (error) {
      console.error('Tax calculation error:', error);
      throw error;
    }
  }

   // Fetch titles from API
    async getTitles() {
      try {
        const response = await fetch(`${API_BASE_URL}/fe/titleListing`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();

        if (!response.ok) {
          return {
            status: false,
            message: data.message || 'Failed to fetch titles',
            data: []
          };
        }

        console.log('Titles fetched successfully:', data);
        return data;

      } catch (error) {
        console.error('Failed to fetch titles:', error);
        return {
          status: false,
          message: 'Failed to fetch titles',
          data: []
        };
      }
    }

  // Fetch countries from API
  async getCountries() {
    try {
      const response = await fetch(`${API_BASE_URL}/fo/countryList`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (!response.ok) {
        // Return a fallback structure
        return {
          data: {},
          message: data.message || 'Failed to fetch countries',
          code: response.status,
          response: 'ERROR'
        };
      }

      console.log('Countries fetched successfully:', data);
      return data;

    } catch (error) {
      console.error('Failed to fetch countries:', error);
      // Return fallback countries
      return {
        data: {
          'IN': 'India',
          'US': 'United States',
          'GB': 'United Kingdom',
          'CA': 'Canada',
          'AU': 'Australia',
          'DE': 'Germany',
          'FR': 'France',
          'JP': 'Japan',
          'CN': 'China',
          'SG': 'Singapore',
          'AE': 'United Arab Emirates'
        },
        message: 'Using fallback countries',
        code: 200,
        response: 'OK'
      };
    }
  }


  // Get user profile data
async getUserProfile(userId) {
  try {
    const payload = {
      user_id: userId,
      shop_code: SHOP_ID
    };

    console.log('Fetching user profile with payload:', payload);
     const params = new URLSearchParams(payload).toString();

    const response = await fetch(
      `${API_BASE_URL}/fe/get-user?${params}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }
    );

    const data = await response.json();

    if (!response.ok) {
      console.error('API Error Response:', data);
      return {
        success: false,
        message: data.message || 'Failed to fetch user profile',
        data: null
      };
    }

    console.log('User profile fetched successfully:', data);

    // Transform API response to match our frontend structure if needed
    return {
      success: data.success,
      message: data.message,
      data: data.data
    };

  } catch (error) {
    console.error('Failed to fetch user profile:', error);
    return {
      success: false,
      message: 'Network error. Please try again.',
      data: null
    };
  }
}

// Update user profile
// Update user profile
async updateUserProfile(userId, profileData) {
  try {
    // Prepare the payload - only send the fields we want to update
    const payload = {
      user_id: userId,
      shop_code: SHOP_ID,
      title_id: profileData.title_id || null,
      firstName: profileData.firstName || '',
      lastName: profileData.lastName || '',
      phone: profileData.phone || '',
      city: profileData.city || '',
      pincode: profileData.pincode || '',
      address: profileData.address || '',
      company_name: profileData.companyName, // Make sure this matches API field name
      designation: profileData.designation,  
      date_of_birth: profileData.dateOfBirth
    };

    console.log('Updating profile with payload:', payload);

    const response = await fetch(`${API_BASE_URL}/fe/update-user`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('API Error Response:', data);
      return {
        success: false,
        message: data.message || 'Failed to update profile',
        data: null
      };
    }

    console.log('Profile updated successfully:', data);

    return {
      success: data.success,
      message: data.message,
      data: data.data
    };

  } catch (error) {
    console.error('Failed to update profile:', error);
    return {
      success: false,
      message: 'Network error. Please try again.',
      data: null
    };
  }
}

// Get user bookings
async getUserBookings(userId) {
  try {
    const payload = {
      user_id: userId,
      shop_code: SHOP_ID
    };

    console.log('Fetching user bookings with payload:', payload);
   const params = new URLSearchParams(payload).toString();

    const response = await fetch(
          `${API_BASE_URL}/fe/user-booking?${params}`,
          {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            }
          }
        );


    const data = await response.json();

    if (!response.ok) {
      console.error('API Error Response:', data);
      return {
        success: false,
        message: data.message || 'Failed to fetch user bookings',
        data: { upcoming: [], previous: [] }
      };
    }

    console.log('User bookings fetched successfully:', data);

    return {
      success: data.success,
      message: data.message,
      data: data.data
    };

  } catch (error) {
    console.error('Failed to fetch user bookings:', error);
    return {
      success: false,
      message: 'Network error. Please try again.',
      data: { upcoming: [], previous: [] }
    };
  }
}

// Cancel booking
async cancelBooking(bookingId) {
  try {
    const userData = sessionStorage.getItem('userData');
    let userId = null;
   
    
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        userId = parsedUser.id_mst_guest_detail;
       
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    }

    if (!userId) {
      return {
        success: false,
        message: 'User not logged in',
        data: null
      };
    }

    const payload = {
      booking_id: bookingId,
      user_id: userId,
      shop_code: SHOP_ID
    };

    const response = await fetch(`${API_BASE_URL}/fe/cancel-booking`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message: data.message || 'Failed to cancel booking',
        data: null
      };
    }

    return {
      success: data.success,
      message: data.message,
      data: data.data
    };

  } catch (error) {
    console.error('Failed to cancel booking:', error);
    return {
      success: false,
      message: 'Network error. Please try again.',
      data: null
    };
  }
}


async checkInventoryAvailability(hotelId, startDate, endDate) {
  try {
    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
      shop_id: SHOP_ID
    }).toString();

    const response = await fetch(
      `${API_BASE_URL}/fe/hotel-inventory-check/${hotelId}?${params}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }
    );

    const data = await response.json();

    if (!response.ok) {
      console.error('Inventory check API error:', data);
      return {
        success: false,
        data: {
          dates: {},
          has_any_available: false
        }
      };
    }

    return {
      success: data.success === true,
      data: data.data || { dates: {}, has_any_available: false }
    };

  } catch (error) {
    console.error('Failed to check inventory:', error);
    return {
      success: false,
      data: {
        dates: {},
        has_any_available: false
      }
    };
  }
}

 
  // Static data for development
  getStaticHotelData() {
    return {
       "hotel_info": {
        "id": 1,
        "name": "Test Hotel",
        "total_rooms": 20,
        "currency": "INR",
        "currency_symbol": "₹",
        "status": 1
      },
       "categories": [
        {
          "category_id": 1,
          "category_name": "Deluxe Suite",
          "total_rooms": 5,
          "description": "Luxurious suite with premium amenities",
          "no_adults_allowed": 2,
            "no_childs_allowed": 0,
            "no_extrabeds_allowed": 1,
          "size": "45-sq ft",
          "maxGuests": 3,
          "images": [
            "https://r1imghtlak.mmtcdn.com/317aa1c6493b11ed86580a58a9feac02.jpg",
            "https://r1imghtlak.mmtcdn.com/e8749cc2493b11ed94860a58a9feac02.jpg"
          ],
          "features": {
    "Beds and Blankets": [
      "King Bed (6x6 ft)",
      "Premium Egyptian Cotton Sheets",
      "4 Pillows (2 Soft, 2 Firm)",
      "Extra Blanket on request"
    ],
    "Room Amenities": [
      "Mini-bar",
      "Electric Kettle",
      "Coffee/Tea making facilities",
      "Bottled Water (Complimentary)",
      "Iron & Ironing Board"
    ],
    "Room Features": [
      "Ocean View",
      "Private Balcony",
      "Work Desk",
      "LED TV (55-inch)",
      "Soundproof Windows"
    ],
    "Bathroom": [
      "Marble Bath",
      "Rain Shower",
      "Separate Bathtub",
      "Premium Toiletries",
      "Hairdryer",
      "Bathrobes & Slippers"
    ],
    "Safety": [
      "In-room Safe",
      "Smoke Detector",
      "Fire Extinguisher",
      "24/7 Security",
      "Electronic Door Lock"
    ]
  },
          "available_rooms": [
            {
              "room_id": 41,
              "room_no": "202"
            },
            {
              "room_id": 45,
              "room_no": "203"
            }
          ],
          "rate_plans": [
            {
              "id": 4,
              "name": "AP",
              "price": 15500,
              "originalPrice": 17000,
              "offer": {
                "discount_name": "base_dicount",
                "discount_percentage": "50%",
              },
              "adult_pricing": [
                {
                  "adults_count": 1,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 2,
                  "original_price": 3000,
                  "price": 1000
                },
                {
                  "adults_count": 5,
                  "original_price": 4000,
                  "price": 2000
                }
              ],
              "child_pricing": [

              ],
              "extra_bed_pricing":[
                {
                  "adult_extra_bed_qty":1,
                  "adult_extra_bed_price":2000
                }
              ],
              "extra_child_pricing": {
                        "qty": 1,
                        "price": 1500
                },
              "inclusions":[
                "All Meals Included (Breakfast, Lunch, Dinner)",
                "Gala Dinner included (Worth ₹2500)",
                "Comp. Airport Transfer (Two-way)",
                "Jeep Safari (Evening Slot)"
              ]
            },
            {
              "id": 5,
              "name": "MEP",
              "price": 15500,
              "originalPrice": 17000,
              "offer": {
                "discount_name": "base_dicount",
                "discount_percentage": "50%"
              },
              "adult_pricing": [
                {
                  "adults_count": 1,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 2,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 7,
                  "original_price": 4000,
                  "price": 2000
                }
              ],
              "child_pricing": [
               
              ],
              "extra_bed_pricing":[
                {
                  "adult_extra_bed_qty":1,
                  "adult_extra_bed_price":600
                }
              ],
              "extra_child_pricing": {
                        "qty": 1,
                        "price": 1500
                    },
              "inclusions":[
                "All Meals Included (Breakfast, Lunch, Dinner)",
                "Gala Dinner included (Worth ₹2500)",
                "Comp. Airport Transfer (Two-way)",
                "Jeep Safari (Evening Slot)"
              ]
            },
            {
              "id": 6,
              "name": "Ep",
              "price": 15500,
              "originalPrice": 17000,
              "offer": {
                "discount_name": "base_dicount",
                "discount_percentage": "50%"
              },
              "adult_pricing": [
                {
                  "adults_count": 1,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 2,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 3,
                  "original_price": 4000,
                  "price": 2000
                }
              ],
              "child_pricing": [
               
              ],
              "extra_bed_pricing":[
                {
                  "adult_extra_bed_qty":1,
                  "adult_extra_bed_price":1500
                }
              ],
              "extra_child_pricing": {
                        "qty": 1,
                        "price": 1500
                    },
              "inclusions":[
                "All Meals Included (Breakfast, Lunch, Dinner)",
                "Gala Dinner included (Worth ₹2500)",
                "Comp. Airport Transfer (Two-way)",
                "Jeep Safari (Evening Slot)"
              ]
            }
          ],
          "other_offer": [
            {
              
              "offer_name": "Special Packages 123",
              "offers": [
                {
                  "id": 7,
                  "name": "AP",
                  "price": 18200,
                  "originalPrice": 20000,
                  "offer": {
                    "discount_name": "base_discount",
                    "discount_percentage": "50%"
                  },
                  "adult_pricing": [
                    { "adults_count": 1, "original_price": 4000, "price": 3000 },
                    { "adults_count": 2, "original_price": 4000, "price": 3000 },
                    { "adults_count": 3, "original_price": 4000, "price": 3000 }
                  ],
                  "child_pricing": [
                   
                  ],
                  "inclusions": [
                    "Airport Transfer",
                    "Kids Stay Free",
                    "Mini Bar Access",
                    "Jeep Safari (Evening Slot)"
                  ]
                },
                {
                  "id": 8,
                  "name": "MEP",
                  "price": 21000,
                  "originalPrice": 24000,
                  "offer": {
                    "discount_name": "base_discount",
                    "discount_percentage": "50%"
                  },
                  "adult_pricing": [
                    { "adults_count": 1, "original_price": 4000, "price": 3000 },
                    { "adults_count": 2, "original_price": 4000, "price": 3000 },
                    { "adults_count": 3, "original_price": 4000, "price": 3000 }
                  ],
                  "child_pricing": [
                   
                  ],
                  "inclusions": [
                    "Yoga Classes",
                    "24-hour Room Service",
                    "Comp. Airport Transfer (Two-way)",
                    "Swimming Pool Access"
                  ]
                },
                {
                  "id": 9,
                  "name": "EP",
                  "price": 15500,
                  "originalPrice": 17000,
                  "offer": {
                    "discount_name": "base_discount",
                    "discount_percentage": "50%"
                  },
                  "adult_pricing": [
                    { "adults_count": 1, "original_price": 4000, "price": 3000 },
                    { "adults_count": 2, "original_price": 4000, "price": 3000 },
                    { "adults_count": 3, "original_price": 4000, "price": 3000 }
                  ],
                  "child_pricing": [
                   
                  ],
                  "inclusions": [
                    "Birthday/Anniversary Cake",
                    "Late Check-out",
                    "Dining Credit",
                    "Spa Access"
                  ]
                }
              ]
            }
          ],
           "terms_and_conditions": [
                "new terms",
                "second term"
            ]
        },
        {
          "category_id": 3,
          "category_name": "Maharani suit",
          "total_rooms": 2,
          "description": "Royal suite with exquisite decor",
           "no_adults_allowed": 2,
            "no_childs_allowed": 0,
            "no_extrabeds_allowed": 1,
          "size": "60-sq ft",
          "maxGuests": 3,
          "images": [
            "https://r1imghtlak.mmtcdn.com/77087b25-83e5-4434-ac51-36b849a4ed82.jpg",
            "https://r1imghtlak.mmtcdn.com/1a338258493b11ed94860a58a9feac02.jpg"
          ],
          "features": {
    "Beds and Blankets": [
      "King Bed (6x6 ft)",
      "Premium Egyptian Cotton Sheets",
      "4 Pillows (2 Soft, 2 Firm)",
      "Extra Blanket on request"
    ],
    "Room Amenities": [
      "Mini-bar",
      "Electric Kettle",
      "Coffee/Tea making facilities",
      "Bottled Water (Complimentary)",
      "Iron & Ironing Board"
    ],
    "Room Features": [
      "Ocean View",
      "Private Balcony",
      "Work Desk",
      "LED TV (55-inch)",
      "Soundproof Windows"
    ],
    "Bathroom": [
      "Marble Bath",
      "Rain Shower",
      "Separate Bathtub",
      "Premium Toiletries",
      "Hairdryer",
      "Bathrobes & Slippers"
    ],
    "Safety": [
      "In-room Safe",
      "Smoke Detector",
      "Fire Extinguisher",
      "24/7 Security",
      "Electronic Door Lock"
    ]
  },
          "available_rooms": [
            {
              "room_id": 50,
              "room_no": "202"
            }
          ],
          "rate_plans": [
            {
              "id": 7,
              "name": "AP",
              "price": 18200,
              "originalPrice": 20000,
              "offer": {
                "discount_name": "base_dicount",
                "discount_percentage": "50%"
              },
              "adult_pricing": [
                {
                  "adults_count": 1,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 2,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 3,
                  "original_price": 4000,
                  "price": 2000
                }
              ],
              "child_pricing": [
               
              ],
              "extra_bed_pricing":[
                {
                  "adult_extra_bed_qty":1,
                  "adult_extra_bed_price":1500
                }
              ],
              "extra_child_pricing": {
                        "qty": 1,
                        "price": 1000
                },
              "inclusions":[
                "All Meals Included (Breakfast, Lunch, Dinner)",
                "Gala Dinner included (Worth ₹2500)",
                "Comp. Airport Transfer (Two-way)",
                "Jeep Safari (Evening Slot)"
              ]
            },
            {
              "id": 8,
              "name": "MEP",
              "price": 21000,
              "originalPrice": 24000,
              "offer": {
                "discount_name": "base_dicount",
                "discount_percentage": "50%"
              },
              "adult_pricing": [
                {
                  "adults_count": 1,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 2,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 3,
                  "original_price": 4000,
                  "price": 2000
                }
              ],
              "child_pricing": [
               
              ],
              "extra_bed_pricing":[
                {
                  "adult_extra_bed_qty":1,
                  "adult_extra_bed_price":500
                }
              ],
              "extra_child_pricing": {
                        "qty": 1,
                        "price": 1200
                    },
              "inclusions":[
                "All Meals Included (Breakfast, Lunch, Dinner)",
                "Gala Dinner included (Worth ₹2500)",
                "Comp. Airport Transfer (Two-way)",
                "Jeep Safari (Evening Slot)"
              ]
            },
            {
              "id": 9,
              "name": "Ep",
              "price": 15500,
              "originalPrice": 17000,
              "offer": {
                "discount_name": "base_dicount",
                "discount_percentage": "50%"
              },
              "adult_pricing": [
                {
                  "adults_count": 1,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 2,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 3,
                  "original_price": 4000,
                  "price": 2000
                }
              ],
              "child_pricing": [
              
              ],
              "extra_bed_pricing":[
                {
                  "adult_extra_bed_qty":1,
                  "adult_extra_bed_price":1700
                }
              ],
              "extra_child_pricing": {
                        "qty": 1,
                        "price": 580
                    },
              "inclusions":[
                "All Meals Included (Breakfast, Lunch, Dinner)",
                "Gala Dinner included (Worth ₹2500)",
                "Comp. Airport Transfer (Two-way)",
                "Jeep Safari (Evening Slot)"
              ]
            }
          ],
         "other_offer": [
            {
              "id": 1,
              "offer_name": "Special Packages",
              "offers": [
                {
                  "id": 7,
                  "name": "AP",
                  "price": 18200,
                  "originalPrice": 20000,
                  "offer": {
                    "discount_name": "base_discount",
                    "discount_percentage": "50%"
                  },
                  "adult_pricing": [
                    { "adults_count": 1, "original_price": 4000, "price": 3000 },
                    { "adults_count": 2, "original_price": 4000, "price": 3000 },
                    { "adults_count": 3, "original_price": 4000, "price": 3000 }
                  ],
                  "child_pricing": [
                    
                  ],
                  "inclusions": [
                    "Airport Transfer",
                    "Kids Stay Free",
                    "Mini Bar Access",
                    "Jeep Safari (Evening Slot)"
                  ]
                },
                {
                  "id": 8,
                  "name": "MEP",
                  "price": 21000,
                  "originalPrice": 24000,
                  "offer": {
                    "discount_name": "base_discount",
                    "discount_percentage": "50%"
                  },
                  "adult_pricing": [
                    { "adults_count": 1, "original_price": 4000, "price": 3000 },
                    { "adults_count": 2, "original_price": 4000, "price": 3000 },
                    { "adults_count": 3, "original_price": 4000, "price": 3000 }
                  ],
                  "child_pricing": [
                   
                  ],
                  "inclusions": [
                    "Yoga Classes",
                    "24-hour Room Service",
                    "Comp. Airport Transfer (Two-way)",
                    "Swimming Pool Access"
                  ]
                },
                {
                  "id": 9,
                  "name": "EP",
                  "price": 15500,
                  "originalPrice": 17000,
                  "offer": {
                    "discount_name": "base_discount",
                    "discount_percentage": "50%"
                  },
                  "adult_pricing": [
                    { "adults_count": 1, "original_price": 4000, "price": 3000 },
                    { "adults_count": 2, "original_price": 4000, "price": 3000 },
                    { "adults_count": 3, "original_price": 4000, "price": 3000 }
                  ],
                  "child_pricing": [
                    
                  ],
                  "inclusions": [
                    "Birthday/Anniversary Cake",
                    "Late Check-out",
                    "Dining Credit",
                    "Spa Access"
                  ]
                }
              ]
            }
          ],

           "terms_and_conditions": [
                "new terms",
                "second term"
            ]
        },
        {
          "category_id": 4,
          "category_name": "Super Delux",
          "total_rooms": 13,
          "description": "Comfortable rooms with all essential amenities",
           "no_adults_allowed": 2,
            "no_childs_allowed": 0,
            "no_extrabeds_allowed": 1,
          "size": "35-sq ft",
          "maxGuests": 3,
          "images": [
            "https://r1imghtlak.mmtcdn.com/4792c4bf-ec14-48e3-a471-e9f675f5171c.jpeg",
            "https://r1imghtlak.mmtcdn.com/f04c6436493b11ed94860a58a9feac02.jpg",
            "https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/201807241617257917-768ef60c822e11e897910242ac110002.jpg"
          ],
          "features": {
    "Beds and Blankets": [
      "King Bed (6x6 ft)",
      "Premium Egyptian Cotton Sheets",
      "4 Pillows (2 Soft, 2 Firm)",
      "Extra Blanket on request"
    ],
    "Room Amenities": [
      "Mini-bar",
      "Electric Kettle",
      "Coffee/Tea making facilities",
      "Bottled Water (Complimentary)",
      "Iron & Ironing Board"
    ],
    "Room Features": [
      "Ocean View",
      "Private Balcony",
      "Work Desk",
      "LED TV (55-inch)",
      "Soundproof Windows"
    ],
    "Bathroom": [
      "Marble Bath",
      "Rain Shower",
      "Separate Bathtub",
      "Premium Toiletries",
      "Hairdryer",
      "Bathrobes & Slippers"
    ],
    "Safety": [
      "In-room Safe",
      "Smoke Detector",
      "Fire Extinguisher",
      "24/7 Security",
      "Electronic Door Lock"
    ]
  },
          "available_rooms": [
            {
              "room_id": 14,
              "room_no": "114"
            },
            {
              "room_id": 15,
              "room_no": "115"
            },
            {
              "room_id": 16,
              "room_no": "116"
            },
            {
              "room_id": 17,
              "room_no": "117"
            },
            {
              "room_id": 18,
              "room_no": "118"
            },
            {
              "room_id": 19,
              "room_no": "119"
            },
            {
              "room_id": 51,
              "room_no": "203"
            },
            {
              "room_id": 52,
              "room_no": "204"
            }
          ],
          "rate_plans": [
            {
              "id": 10,
              "name": "AP",
              "price": 9000,
              "originalPrice": 10500,
              "offer": {
                "discount_name": "base_dicount",
                "discount_percentage": "50%"
              },
              "adult_pricing": [
                {
                  "adults_count": 1,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 2,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 3,
                  "original_price": 4000,
                  "price": 2000
                }
              ],
              "child_pricing": [
               
              ],
              "extra_bed_pricing":[
                {
                  "adult_extra_bed_qty":1,
                  "adult_extra_bed_price":1500
                }
              ],
              "inclusions":[
                "All Meals Included (Breakfast, Lunch, Dinner)",
                "Gala Dinner included (Worth ₹2500)",
                "Comp. Airport Transfer (Two-way)",
                "Jeep Safari (Evening Slot)"
              ]
            },
            {
              "id": 11,
              "name": "MEP",
              "price": 10200,
              "originalPrice": 11500,
              "offer": {
                "discount_name": "base_dicount",
                "discount_percentage": "50%"
              },
              "adult_pricing": [
                {
                  "adults_count": 1,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 2,
                  "original_price": 4000,
                  "price": 2000
                },
                {
                  "adults_count": 3,
                  "original_price": 4000,
                  "price": 2000
                }
              ],
              "child_pricing": [
                
              ],
              "extra_bed_pricing":[
                {
                  "adult_extra_bed_qty":1,
                  "adult_extra_bed_price":100
                }
              ],
              "inclusions":[
                "All Meals Included (Breakfast, Lunch, Dinner)",
                "Gala Dinner included (Worth ₹2500)",
                "Comp. Airport Transfer (Two-way)",
                "Jeep Safari (Evening Slot)"
              ]
            }
          ],
           "terms_and_conditions": [
                "new terms",
                "second term"
            ]
        }
      ],
      "rooms": [
        {
          "id": 1,
          "room_no": "101",
          "room_category_id": 1,
          "available": false
        },
        {
          "id": 6,
          "room_no": "106",
          "room_category_id": 1,
          "available": false
        },
        {
          "id": 8,
          "room_no": "108",
          "room_category_id": 4,
          "available": false
        },
        {
          "id": 9,
          "room_no": "109",
          "room_category_id": 4,
          "available": false
        },
        {
          "id": 10,
          "room_no": "110",
          "room_category_id": 4,
          "available": false
        },
        {
          "id": 11,
          "room_no": "111",
          "room_category_id": 4,
          "available": false
        },
        {
          "id": 12,
          "room_no": "112",
          "room_category_id": 4,
          "available": false
        },
        {
          "id": 14,
          "room_no": "114",
          "room_category_id": 4,
          "available": true
        },
        {
          "id": 15,
          "room_no": "115",
          "room_category_id": 4,
          "available": true
        },
        {
          "id": 16,
          "room_no": "116",
          "room_category_id": 4,
          "available": true
        },
        {
          "id": 17,
          "room_no": "117",
          "room_category_id": 4,
          "available": true
        },
        {
          "id": 18,
          "room_no": "118",
          "room_category_id": 4,
          "available": true
        },
        {
          "id": 19,
          "room_no": "119",
          "room_category_id": 4,
          "available": true
        },
        {
          "id": 41,
          "room_no": "202",
          "room_category_id": 1,
          "available": true
        },
        {
          "id": 45,
          "room_no": "203",
          "room_category_id": 1,
          "available": true
        },
        {
          "id": 47,
          "room_no": "102",
          "room_category_id": 1,
          "available": false
        },
        {
          "id": 49,
          "room_no": "201",
          "room_category_id": 3,
          "available": false
        },
        {
          "id": 50,
          "room_no": "202",
          "room_category_id": 3,
          "available": true
        },
        {
          "id": 51,
          "room_no": "203",
          "room_category_id": 4,
          "available": true
        },
        {
          "id": 52,
          "room_no": "204",
          "room_category_id": 4,
          "available": true
        }
      ]
    };
  }
}

// Create and export a singleton instance
export const apiService = new ApiService();